export default {
  computed: {
    access_level() {
      // return 2;
      return this.$store.state.user.access_level;
    },
    showOriginal() {
      return this.access_level < 2;
    },
    showTranslation() {
      return this.access_level >= 2;
    },
    showAddAndDelete() {
      return this.access_level < 2;
    },
    langcode() {
      return this.$i18n.locale;
    },
    flag() {
      return this.$i18n.locale == 'sv' ? 'se' : this.$i18n.locale; // Fix for Swedish flag (sv -> se)
    },
  },
  methods: {
    getValue(item, key, value = null) {
      const val = value !== null ? value : item[key];
      return this.showTranslation && item.translations[this.langcode] ? item.translations[this.langcode][key] : val;
    },
  }
}